import { Alert } from "../classes/Alert";
import AlertComponent from "../components/layout/AlertComponent";

const AlertPlugin = {
    install(app) {
        app.component("alert-component", AlertComponent);
        app.config.globalProperties.$alert = new Alert();
    }
};

export default AlertPlugin;